module.exports = veUtilitiesMfeConfig;